export function ToOffset(date: Date, offsetHours: number) {
    // Create a new Date instance from the original date
    const originalDate = new Date(date);

    // Get the UTC time of the original date
    const utcTime = originalDate.getTime() + (originalDate.getTimezoneOffset() * 60000);

    // Add the specified offset in milliseconds (offsetHours * 60 minutes * 60 seconds * 1000 milliseconds)
    const offsetTime = utcTime + offsetHours * 60 * 60 * 1000;

    // Return a new Date object with the adjusted time
    return new Date(offsetTime);
}